import { Container } from "../Container";
export class Shader extends Container {
    get shader() {
        return this.el.shader;
    }
    set shader(v) {
        this.el.shader = v;
    }
    set ["shader-factory"](v) {
        this.shader = v(this.stage.context);
    }
}
//# sourceMappingURL=Shader.js.map